import { render, staticRenderFns } from "./VLink.vue?vue&type=template&id=4d4f2138&"
import script from "./VLink.vue?vue&type=script&lang=ts&"
export * from "./VLink.vue?vue&type=script&lang=ts&"
import style0 from "./VLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports